(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fdbs-buy-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('input',event=>{if(event.target.matches('[data-fdbs-counter]')){event.target.closest('label').querySelector('.fdbs-counter').textContent=`${event.target.value.length} / ${event.target.maxLength}`;}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fdbs-print-configurator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fdbs-print-configurator')) {
  class FdbsPrintConfigurator extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.catalog = JSON.parse(this.querySelector('[data-print-catalog]').textContent);
      this.live = JSON.parse(this.querySelector('[data-print-live]').textContent);
      this.money = new Intl.NumberFormat('de-DE', {style:'currency',currency:'EUR'});
      this.form = this.querySelector('form');
      this.sizeSelect = this.querySelector('[data-print-size]');
      this.common = this.querySelector('[data-print-common]');
      this.materialKey = (this.catalog.materials.find(m => m.handle === this.dataset.initialMaterial) || this.catalog.materials[0]).key;
      this.rowId = '60x40';
      this.delivery = 'PAH';
      this.querySelectorAll('input[name="print_material"]').forEach(input => { input.checked = input.value === this.materialKey; });
      this.querySelectorAll('[data-print-min]').forEach(node => {
        const prices = this.rowsFor(node.dataset.printMin).map(row => this.priceFor(node.dataset.printMin,row,'PAH'));
        node.textContent = this.money.format(Math.min.apply(null,prices)/100);
      });
      this.addEventListener('change', event => {
        if (event.target.name === 'print_material') {
          this.materialKey = event.target.value;
          this.renderFormats();
        } else if (event.target.matches('[data-print-size]')) {
          this.rowId = event.target.value;
          this.querySelector('[data-print-size-notice]').hidden = true;
          this.update();
        } else if (event.target.name === 'print_delivery') {
          this.delivery = event.target.value;
          this.update();
        }
      });
      this.common.addEventListener('click', event => {
        const button = event.target.closest('[data-print-row]');
        if (!button) return;
        this.rowId = button.dataset.printRow;
        this.querySelector('[data-print-size-notice]').hidden = true;
        this.update();
      });
      this.addEventListener('input', event => {
        if (!event.target.matches('[data-print-personal]')) return;
        const input = event.target;
        input.closest('label').querySelector('[data-print-counter]').textContent = input.value.length + ' / ' + input.maxLength;
        this.updatePersonal();
      });
      this.querySelector('[data-print-submit]').addEventListener('click', () => this.form.requestSubmit());
      this.form.addEventListener('submit', event => {
        if (!this.canBuy()) {
          event.preventDefault();
          this.querySelector('[data-print-error]').hidden = false;
        }
      });
      this.renderFormats();
      this.updatePersonal();
    }
    rowsFor(material) {
      return this.catalog.rows.filter(row => Number.isFinite(row.prices[material]));
    }
    variantFor(material,row,delivery) {
      if (!row) return null;
      const spec = this.catalog.materials.find(item => item.key === material);
      if (!spec) return null;
      const sku = 'FDBS-GS-PRINT-' + spec.sku + '-' + row.id.toUpperCase() + '-' + delivery;
      return ((this.live.products[material] || {}).variants || []).find(variant => variant.sku === sku) || null;
    }
    priceFor(material,row,delivery) {
      const variant = this.variantFor(material,row,delivery);
      return variant ? variant.price : Math.round(row.prices[material]*100);
    }
    currentRow() {
      return this.rowsFor(this.materialKey).find(row => row.id === this.rowId);
    }
    canBuy() {
      const variant = this.variantFor(this.materialKey,this.currentRow(),this.delivery);
      return Boolean(this.live.enabled && variant && variant.available);
    }
    renderFormats() {
      const rows = this.rowsFor(this.materialKey);
      const notice = this.querySelector('[data-print-size-notice]');
      notice.hidden = true;
      if (!rows.some(row => row.id === this.rowId)) {
        const previous = this.catalog.rows.find(row => row.id === this.rowId);
        const replacement = rows.find(row => row.id === '30x20') || rows[0];
        this.rowId = replacement.id;
        notice.textContent = (previous ? previous.format : 'Das bisherige Format') + ' ist in diesem Material nicht verfügbar. Vorausgewählt: ' + replacement.format + '. Bitte die Größe prüfen oder ein anderes Format wählen.';
        notice.hidden = false;
      }
      this.common.replaceChildren();
      this.catalog.common.forEach(id => {
        const row = rows.find(item => item.id === id);
        if (!row) return;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'fdbs-print-size';
        button.dataset.printRow = row.id;
        const label = document.createElement('span');
        label.textContent = row.format;
        const price = document.createElement('small');
        price.textContent = this.money.format(this.priceFor(this.materialKey,row,this.delivery)/100);
        button.append(label,price);
        this.common.append(button);
      });
      this.sizeSelect.replaceChildren();
      this.catalog.groups.forEach(group => {
        const entries = rows.filter(row => row.group === group);
        if (!entries.length) return;
        const optgroup = document.createElement('optgroup');
        optgroup.label = group;
        entries.forEach(row => {
          const option = document.createElement('option');
          option.value = row.id;
          option.textContent = row.format + ' · ' + this.money.format(this.priceFor(this.materialKey,row,this.delivery)/100);
          optgroup.append(option);
        });
        this.sizeSelect.append(optgroup);
      });
      this.update();
    }
    update() {
      const row = this.currentRow();
      if (!row) return;
      const material = this.catalog.materials.find(item => item.key === this.materialKey);
      this.sizeSelect.value = row.id;
      this.common.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.printRow === row.id)));
      this.querySelector('[data-print-detail]').textContent = material.detail;
      this.querySelector('[data-print-summary-material]').textContent = material.label;
      this.querySelector('[data-print-summary-format]').textContent = row.format;
      this.querySelector('[data-print-price]').textContent = this.money.format(this.priceFor(this.materialKey,row,this.delivery)/100);
      this.querySelector('[data-print-material-property]').value = material.label;
      this.querySelector('[data-print-format-property]').value = row.format;
      const shipping = this.querySelector('[data-print-shipping]');
      shipping.textContent = this.delivery === 'POST' ? shipping.dataset.post : shipping.dataset.pdf;
      const variant = this.variantFor(this.materialKey,row,this.delivery);
      const hidden = this.querySelector('[data-print-variant]');
      hidden.value = variant ? variant.id : '';
      hidden.disabled = !this.canBuy();
      const button = this.querySelector('[data-print-submit]');
      button.disabled = !this.canBuy();
      button.textContent = this.canBuy() ? button.dataset.add : button.dataset.preparing;
      this.querySelector('[data-print-status]').hidden = this.canBuy();
      this.querySelector('[data-print-error]').hidden = true;
    }
    updatePersonal() {
      ['recipient','sender','message'].forEach(key => {
        const input = this.querySelector('[data-print-personal="' + key + '"]');
        const output = this.querySelector('[data-print-preview-' + key + ']');
        output.textContent = input.value.trim();
        output.hidden = !input.value.trim();
      });
    }
  }
  customElements.define('fdbs-print-configurator',FdbsPrintConfigurator);
}
function fdbsSyncGiftPanels() {
  const print = window.location.hash === '#druck-gutscheine';
  document.querySelectorAll('[data-fdbs-gift-panel]').forEach(panel => { panel.hidden = (panel.dataset.fdbsGiftPanel === 'print') !== print; });
  document.querySelectorAll('[data-fdbs-gift-tab]').forEach(link => {
    if ((link.dataset.fdbsGiftTab === 'print') === print) link.setAttribute('aria-current','page');
    else link.removeAttribute('aria-current');
  });
  document.querySelectorAll('[data-fdbs-shooting-faq]').forEach(section => { section.hidden = print; });
}
window.addEventListener('hashchange',fdbsSyncGiftPanels);
document.addEventListener('DOMContentLoaded',fdbsSyncGiftPanels);
document.addEventListener('shopify:section:load',fdbsSyncGiftPanels);
fdbsSyncGiftPanels();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fdbs-shooting-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fdbs-shooting-picker')) {
 class FdbsShootingPicker extends HTMLElement {
  connectedCallback() {
   if (this.onRoute) return;
   this.chooser=this.querySelector('[data-shoot-chooser]');
   this.panels=Array.from(this.querySelectorAll('[data-shoot-panel]'));
   this.onRoute=()=>this.route(true);
   window.addEventListener('hashchange',this.onRoute);
   window.addEventListener('popstate',this.onRoute);
   this.route(false);
  }
  disconnectedCallback() { window.removeEventListener('hashchange',this.onRoute);window.removeEventListener('popstate',this.onRoute);this.onRoute=null; }
  route(focus) {
   let hash=window.location.hash;
   const aliases={'#geschenk-family':'#geschenk-familie-klassik','#geschenk-family-plus':'#geschenk-familie-plus','#geschenk-children-baby':'#geschenk-familie-start'};
   hash=aliases[hash]||hash;
   const packageKey=hash.startsWith('#geschenk-')?hash.slice('#geschenk-'.length):'';
   const selectedPackage=Array.from(this.querySelectorAll('[data-shoot-package]')).find(item=>item.dataset.shootPackage===packageKey);
   const panel=selectedPackage?selectedPackage.closest('[data-shoot-panel]'):this.panels.find(item=>hash==='#'+item.id);
   this.chooser.hidden=Boolean(panel);
   this.panels.forEach(item=>{item.hidden=item!==panel;});
   if(panel&&selectedPackage) selectedPackage.querySelector('details').open=true;
   if(focus&&panel) requestAnimationFrame(()=>{const title=panel.querySelector('h3');title.focus({preventScroll:true});(selectedPackage||panel).scrollIntoView({block:'start'});});
  }
 }
 customElements.define('fdbs-shooting-picker',FdbsShootingPicker);
}
  } catch(e) { console.error(e); }
})();

})();
